module.exports = __webpack_public_path__ + "static/media/wikipedia-network.444effef.mp4";